type LazyLoadOptions = {
    onSuccess: (html: string) => void;
    onError: () => void;
    cacheKey?: string;
    cacheTtl?: number;
};

export function lazyLoad(el: HTMLElement, url: string, options: LazyLoadOptions) {
    const { onSuccess, onError, cacheKey, cacheTtl } = options;

    if (cacheKey && cacheTtl) {
        try {
            const cached = sessionStorage.getItem(cacheKey);
            if (cached) {
                const data = JSON.parse(cached);
                if (data.html && (Date.now() - data.ts) < cacheTtl * 1000) {
                    onSuccess(data.html);
                    return;
                }
                sessionStorage.removeItem(cacheKey);
            }
        } catch {}
    }

    let loaded = false;

    const load = () => {
        if (loaded) return;
        loaded = true;
        observer.disconnect();
        cleanup();

        fetch(url, { credentials: 'same-origin' })
            .then(res => res.json())
            .then(data => {
                onSuccess(data.html);
                if (cacheKey && cacheTtl) {
                    try {
                        sessionStorage.setItem(cacheKey, JSON.stringify({ html: data.html, ts: Date.now() }));
                    } catch {}
                }
            })
            .catch(() => onError());
    };

    const interactionEvents = ['scroll', 'click', 'touchstart', 'mousemove'] as const;

    const cleanup = () => {
        interactionEvents.forEach(evt => window.removeEventListener(evt, load));
    };

    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) load();
    }, { rootMargin: '200px' });

    observer.observe(el);

    interactionEvents.forEach(evt =>
        window.addEventListener(evt, load, { passive: true })
    );
}
